"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _throttle = _interopRequireDefault(require("transmute/throttle"));

var WithScrollListener =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(WithScrollListener, _Component);

  function WithScrollListener(props) {
    var _this;

    (0, _classCallCheck2.default)(this, WithScrollListener);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithScrollListener).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.onScrollThrottled = (0, _throttle.default)(props.throttleMillis, props.onScroll);
    return _this;
  }

  (0, _createClass2.default)(WithScrollListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var shouldListen = this.props.shouldListen;

      if (shouldListen) {
        _reactDom.default.findDOMNode(this.ref).addEventListener('scroll', this.onScrollThrottled);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var shouldListen = this.props.shouldListen;

      if (shouldListen) {
        _reactDom.default.findDOMNode(this.ref).removeEventListener('scroll', this.onScrollThrottled);
      }
    }
  }, {
    key: "handleRef",
    value: function handleRef(ref) {
      this.ref = ref;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          refName = _this$props.refName,
          children = _this$props.children;
      return _react.default.cloneElement(_react.Children.only(children), (0, _defineProperty2.default)({}, refName, this.handleRef));
    }
  }]);
  return WithScrollListener;
}(_react.Component);

WithScrollListener.propTypes = {
  refName: _propTypes.default.string.isRequired,
  onScroll: _propTypes.default.func.isRequired,
  children: _propTypes.default.element.isRequired,
  shouldListen: _propTypes.default.bool,
  throttleMillis: _propTypes.default.number
};
WithScrollListener.defaultProps = {
  throttleMillis: 50,
  shouldListen: true
};
var _default = WithScrollListener;
exports.default = _default;
module.exports = exports.default;